// Third party
import { createFeatureSelector, createSelector } from '@ngrx/store';

// Local library
import { TError } from '@amwager/util-ts';

// Local file
import { COMMON_FEATURE_KEY } from './common.reducer';
import { ICommonState } from './common.models';



// Lookup the 'Common' feature state managed by NgRx
export const state = createFeatureSelector<ICommonState>(
  COMMON_FEATURE_KEY
);

export const getLoaded = createSelector(
  state,
  (state: ICommonState): boolean | undefined => state?.isLoaded
);

export const getError = createSelector(
  state,
  (state: ICommonState): TError => state?.error
);

export const getIsComponentView = createSelector(
  state,
  (state: ICommonState): boolean | undefined => state?.isComponentView || false
);

export const getIsShowNavigation = createSelector(
  state,
  (state: ICommonState): boolean => state?.isShowNavigation || false
);

export const getIsShowFooter = createSelector(
  state,
  (state: ICommonState): boolean => state?.isShowFooter || false
);

export const getIsAuthenticated = createSelector(
  state,
  (state: ICommonState): boolean => state?.isAuthenticated || false
);

export const getTmsId = createSelector(
  state,
  (state: ICommonState): string | undefined => state?.tmsId
);

export const getPusherData= createSelector(
  state,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (state: ICommonState): any => state?.pusher
);

export const getErrorAPI = createSelector(
  state,
  (state: ICommonState) => state?.isErrorAPI
);

export const getQaTesting = createSelector(
  state,
  (state: ICommonState) => state?.qaTesting
);

export const getIsDismissModal = createSelector(
  state,
  (state: ICommonState) => state?.isDismissModal || false
);

export const getBackNavigation = createSelector(
  state,
  (state: ICommonState) => state?.backNavigation || ''
);

export const getIsConnectedInternet = createSelector(
  state,
  (state: ICommonState) => state?.isConnectedInternet
);
